import React from 'react';
import { useIntl, FormattedTime, FormattedDateTimeRange } from 'react-intl';

interface SessionSlotInput {
    start: Date;
    end: Date;
}

export const sessionDateTimeRangeFormat = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
} as const;

export const useFormattedSessionDateTimeRange = ({ start, end }: SessionSlotInput): string => {
    const intl = useIntl();

    return intl.formatDateTimeRange(start, end, sessionDateTimeRangeFormat);
};

export const FormattedSessionDateTimeRange = ({
    start,
    end,
    ...rest
}: SessionSlotInput & { month?: 'long' | 'short' }) => (
    <FormattedDateTimeRange from={start} to={end} {...sessionDateTimeRangeFormat} {...rest} />
);

export const sessionStartTimeFormat = {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
} as const;

type FormattedSessionStartTimeInput = Pick<SessionSlotInput, 'start'>;

export const useFormattedSessionStartTime = ({ start }: FormattedSessionStartTimeInput): string => {
    const intl = useIntl();

    return intl.formatTime(start, sessionStartTimeFormat);
};

export const FormattedSessionStartTime = ({ start }: FormattedSessionStartTimeInput) => (
    <FormattedTime value={start} {...sessionStartTimeFormat} />
);
